module.exports = __webpack_public_path__ + "img/search-header-with-nav-hyundai.4d2f9823.png";